import { render, staticRenderFns } from "./share-planner-actions.vue?vue&type=template&id=50282e08&scoped=true&"
import script from "./share-planner-actions.vue?vue&type=script&lang=ts&"
export * from "./share-planner-actions.vue?vue&type=script&lang=ts&"
import style0 from "./share-planner-actions.vue?vue&type=style&index=0&id=50282e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50282e08",
  null
  
)

export default component.exports